import React from 'react';
import {
  Container,
  Header,
  Table,
  SpaceBetween,
  Box,
  ExpandableSection
} from '@cloudscape-design/components';

const DomainRelationships = ({ relationships }) => {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Inter-domain relationships and interactions"
        >
          Domain Relationships
        </Header>
      }
    >
      <Table
        columnDefinitions={[
          {
            id: 'source',
            header: 'Source Domain',
            cell: item => item.source_domain
          },
          {
            id: 'target',
            header: 'Target Domain',
            cell: item => item.target_domain
          },
          {
            id: 'type',
            header: 'Relationship Type',
            cell: item => item.relationship_type
          },
          {
            id: 'interactions',
            header: 'Interaction Patterns',
            cell: item => (
              <ExpandableSection header="View Interactions">
                {item.interaction_patterns.map((pattern, index) => (
                  <SpaceBetween size="xs" key={index}>
                    <Box variant="strong">{pattern.type} - {pattern.purpose}</Box>
                    <Box>Data Flow: {pattern.data_flow.join(', ')}</Box>
                    <Box>Consistency: {pattern.consistency_requirement}</Box>
                  </SpaceBetween>
                ))}
              </ExpandableSection>
            )
          }
        ]}
        items={relationships}
        variant="container"
      />
    </Container>
  );
};

export default DomainRelationships;
